<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="sku" label="Sku" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field class='text-body-2' v-model="producto" label="Producto" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-btn @click="d_products=true" class="mt-1" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col>
                <v-col cols="3">
                    <v-alert class='text-body-2' shaped dense text type="info">
                        Selecciona Producto !!!
                    </v-alert>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="fecha" label="Fecha" outlined dense rounded disabled></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="3">
                    <v-text-field class='text-body-2' v-model="variante" label="Variante" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <!-- <v-select class='text-body-2' v-model="dte" :items="itemDTE" label="Selecciona DTE" item-text="doc" item-value="id"></v-select> -->
                    <v-select class='text-body-2' @change="searchPrecio(tipo)" v-model="tipo" :items="precios"  label="Tipo Precio" outlined dense rounded :filled="filled" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="precio" label="Precio Venta" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="cantidad" label="Cantidad" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-icon @click="addProducts()" class="mt-2" color="indigo">add_circle_outline</v-icon>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="8">
                    <v-data-table height="150px" dense
                        :search="search" :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" 
                        hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                        <template v-slot:item.producto="{ item }">
                            {{ item.producto }} - {{ item.variante }}
                        </template>
                        <template v-slot:item.accion="{ item }">
                            <v-icon color="red" small @click="deleteLine(item)">delete</v-icon>
                        </template>
                    </v-data-table>
                </v-col>
                <v-col cols="4">
                    <v-row class="mt-n5">
                        <v-col cols="6">
                            <h5 class="mt-3">Totales</h5>
                        </v-col>
                        <v-col cols="5" class="text-end">
                            <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="porciento" label="Descuento (%)" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-icon @click="addDescuento()" class="mt-2" color="indigo">add_circle_outline</v-icon>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n10">
                        <v-col cols="4">
                        <h5>Neto</h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(neto)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Descuento ({{ txt_desc }}%)</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(descuento)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Afecto</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(afecto)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Iva ({{impuesto}}%)</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(iva)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Total</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(total)}}</h5>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="8" class="mt-2">
                            <strong>FACTURACIÓN</strong>
                            <v-icon class="ml-2" @click="dialogo_factura=true" color="indigo">add_circle_outline</v-icon>
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="dte" :items="tipoDte" label="Tipo DTE" dense outlined rounded></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n10">
                        <v-col cols="12">
                            <v-divider></v-divider>
                            <h5>Rut: <span class="teal--text">{{rut_factura}}</span></h5>
                            <h5>Razon Social: <span class="teal--text">{{razon_factura}}</span></h5>
                            <h5>Direccion: <span class="teal--text">{{direccion_factura}}</span></h5>
                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_factura}} - {{ ciudad_factura }}</span></h5>
                            <h5>Email: <span class="teal--text">{{email_factura}}</span></h5>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider inset vertical></v-divider>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="4" class="mt-2">
                            <strong>DESPACHO</strong>
                            <v-icon class="ml-2" @click="dialogo_despacho=true" color="indigo">add_circle_outline</v-icon>
                        </v-col>
                        <v-col cols="4">
                            <h5>Peso (kg): <span class="teal--text">{{peso_despacho}}</span></h5>
                            <h5>Volumen (cm3): <span class="teal--text">{{volumen_despacho}}</span></h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                            <v-select v-model="transporte" :items="transportes" class='text-body-2' label="Transporte" dense outlined rounded></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n10">
                        <v-col cols="12">
                            <v-divider></v-divider>
                            <h5>Contacto: <span class="teal--text">{{contacto_despacho}}</span></h5>
                            <h5>Direccion: <span class="teal--text">{{direccion_despacho}}</span></h5>
                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_despacho}} - {{ ciudad_despacho }}</span></h5>
                            <h5>Email: <span class="teal--text">{{email_despacho}}</span></h5>
                            <h5>Costo ($): <span class="teal--text">{{costo_despacho}}</span></h5>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="Observacion" class='text-body-2' v-model="observa" dense outlined rounded></v-text-field>
                </v-col>
                <v-col cols="2" class="mt-1">
                    <v-btn @click="clsInput()" color="teal" small dark rounded block><span class="text-body-2">Nuevo</span></v-btn>
                </v-col>
                <v-col cols="2" class="mt-1">
                    <v-btn v-if="btn_grabado==true" @click="savePedido()" color="teal" small dark rounded block><span class="text-body-2">Grabar</span></v-btn>
                    <v-btn v-else color="grey" small dark rounded block><span class="text-body-2">Grabar</span></v-btn>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-body-2' label="N° Pedido" v-model="numero_pedido" dense outlined rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2" class="mt-1 text-center">
                    <v-btn v-if="btn_grabado==false" color="teal" small dark rounded block><span class="text-body-2">Enviar</span></v-btn>
                    <v-btn v-else color="grey" small dark rounded block><span class="text-body-2">Enviar</span></v-btn>
                </v-col>
            </v-row>
        </v-container>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="50%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProductos" dense dark 
                    :search="products_search" :headers="products_titulo" :items="products_lista" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- formulario de facturacion -->
        <v-dialog v-model="dialogo_factura" persistent max-width="350">
            <v-card max-width="350">
                <v-card-title>
                    Datos de Facturación
                    <v-spacer></v-spacer>
                    <v-btn @click="close_factura()" dark rounded x-small>restablecer</v-btn>
                    <!-- <v-icon @click="close_factura()" color="#000">cancel</v-icon> -->
                </v-card-title>
                <v-card-subtitle><h5 class="error--text">* Todos los datos son obligatorios</h5></v-card-subtitle>
                <v-card-text>
                    <v-text-field class="text-body-2" v-model="rut_factura" label="Rut" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="razon_factura" label="Razon Social" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="giro_factura" label="Giro" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="email_factura" label="Email" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="fono_factura" label="Telefono" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="direccion_factura" label="Direccion" outlined dense rounded></v-text-field>
                    <v-select v-if="regiones_factura.length!=0" class="mt-n3 text-body-2" @change="leer_ciudad_factura(region_factura)" v-model="region_factura" :items="regiones" label="Region" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Region" outlined dense rounded disabled></v-select>
                    <v-select v-if="ciudades_factura.length!=0" class="mt-n3 text-body-2" @change="leer_comuna_factura(region_factura,ciudad_factura)" v-model="ciudad_factura" :items="ciudades_factura" label="Provincia" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Provincia" outlined dense rounded disabled></v-select>
                    <v-select v-if="comunas_factura.length!=0" class="mt-n3 text-body-2" v-model="comuna_factura" :items="comunas_factura" label="Ciudad/Comuna" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Ciudad/Comuna" outlined dense rounded disabled></v-select>
                    <v-btn @click="validateRut(rut_factura)" class="mt-3" dark block rounded small>Confirmar</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- formulario de despacho -->
        <v-dialog v-model="dialogo_despacho" persistent max-width="350">
            <v-card max-width="350">
                <v-card-title>
                    Datos del envío
                    <v-spacer></v-spacer>
                    <v-btn @click="close_despacho()" dark rounded x-small>restablecer</v-btn>
                    <!-- <v-icon @click="close_despacho()" color="#000">cancel</v-icon> -->
                </v-card-title>
                <v-card-subtitle>
                    <h5 v-if="transporte=='Retiro en tienda'" class="error--text">* Ingrese contacto y email para retiro</h5>
                    <h5 v-else class="error--text">* Todos los datos son obligatorios</h5>
                </v-card-subtitle>
                <v-card-text>
                    <v-text-field class="mt-n3 text-body-2" v-model="contacto_despacho" label="Nombre Contacto" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="email_despacho" label="Email" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="fono_despacho" label="Telefono" outlined dense rounded></v-text-field>
                    <v-text-field class="mt-n3 text-body-2" v-model="direccion_despacho" label="Direccion" outlined dense rounded></v-text-field>
                    <v-select v-if="regiones.length!=0" class="mt-n3 text-body-2" @change="leer_ciudad(region_despacho)" v-model="region_despacho" :items="regiones" label="Region" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Region" outlined dense rounded disabled></v-select>
                    <v-select v-if="ciudades.length!=0" class="mt-n3 text-body-2" @change="leer_comuna(region_despacho,ciudad_despacho)" v-model="ciudad_despacho" :items="ciudades" label="Provincia" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Provincia" outlined dense rounded disabled></v-select>
                    <v-select v-if="comunas.length!=0" class="mt-n3 text-body-2" v-model="comuna_despacho" :items="comunas" label="Ciudad/Comuna" outlined dense rounded></v-select>
                    <v-select v-else class="mt-n3 text-body-2" label="Ciudad/Comuna" outlined dense rounded disabled></v-select>
                    <v-btn @click="confirmaDespacho()" class="mt-3" dark block rounded small>Confirmar</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>

    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Pedidos',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    hoy:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    fecha:'',
    sku:'',
    producto:'',
    variante:'',
    tipo:'',
    precios:['Precio Detalle','Precio Oferta','Precio Mayor'],
    lista_precio:[],
    precio:'',
    cantidad:'',
    peso:'',
    volumen:'',
    filled:true,
    disabled:true,
    headers: [
      { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
      { text: 'Producto - Variante', align: 'start', sortable: true, value: 'producto' },
      { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
      { text: 'Cantidad', align: 'start', sortable: false, value: 'cantidad' },
      { text: 'Total', align: 'start', sortable: false, value: 'total' },
      { text: '', align: 'start', sortable: false, value: 'accion' },
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 1000000,
    search:'',

    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Variante', align: 'start', sortable: true, value: 'variante' },
    ],
    products_lista: [],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',

    neto:0,
    porciento:0,
    descuento:0,
    txt_desc:0,
    impuesto:'19',
    iva:0,
    afecto:0,
    total:0,
    numero_pedido:0,
    observa:'',
    dte:'Boleta',
    tipoDte:['Boleta', 'Factura'],
    transporte:'Retiro en tienda',
    transportes:['Retiro en tienda'],
    pais:'Chile',
    regiones:[],
    ciudades:[],
    comunas:[],
    regiones_factura:[],
    ciudades_factura:[],
    comunas_factura:[],

    //formulario factura
    dialogo_factura:false,
    rut_factura:'',
    razon_factura:'',
    giro_factura:'',
    email_factura:'',
    fono_factura:'',
    region_factura:'',
    direccion_factura:'',
    comuna_factura:'',
    ciudad_factura:'',

    //formulario despacho
    dialogo_despacho:false,
    contacto_despacho:'',
    email_despacho:'',
    fono_despacho:'',
    region_despacho:'',
    direccion_despacho:'',
    comuna_despacho:'',
    ciudad_despacho:'',
    costo_despacho:0,
    peso_despacho:'',
    volumen_despacho:'',

    numClicks:0,
    array_pedido:[],
    portal:'99',
    btn_grabado:true,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.fecha=this.formatFecha(this.hoy);
    await this.searchImpuesto();
    await this.searchProducts();
    await this.leer_region();
    this.bloqueo = await this.myPermiso(5);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    clsInput(){
    this.sku='';
    this.producto='';
    this.variante='';
    this.tipo='';
    this.precio='';
    this.cantidad='';
    this.peso='';
    this.volumen='';
    this.filled=true;
    this.disabled=true;
    this.items=[];
    this.neto=0;
    this.porciento=0;
    this.descuento=0;
    this.txt_desc=0;
    this.iva=0;
    this.afecto=0;
    this.total=0;
    this.numero_pedido=0;
    this.observa='';
    this.dte='Boleta',
    this.transporte='Retiro en tienda',
    //formulario factura
    this.rut_factura='';
    this.razon_factura='';
    this.giro_factura='';
    this.email_factura='';
    this.fono_factura='';
    this.region_factura='';
    this.direccion_factura='';
    this.comuna_factura='';
    this.ciudad_factura='';
    //formulario despacho
    this.contacto_despacho='';
    this.email_despacho='';
    this.fono_despacho='';
    this.region_despacho='';
    this.direccion_despacho='';
    this.comuna_despacho='';
    this.ciudad_despacho='';
    this.costo_despacho=0;
    this.peso_despacho='';
    this.volumen_despacho='';
    this.numClicks=0;
    this.array_pedido=[];
    this.portal='99';
    this.btn_grabado=true;
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    async searchImpuesto(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/impuesto/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.impuesto = datos[0].valor 
            }
        } catch (error) {
            console.log(error)
        }
    },
    async searchProducts(){
        try {
            this.products_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    handleProductos(item){
        this.tipo='',
        this.precio='',
        this.cantidad='',
        this.sku = item.codigo;
        this.producto = item.producto;
        this.variante = item.variante;
        this.peso = item.peso;
        this.volumen = item.volumen;
        //llenamos los precios,
        this.lista_precio=[],
        this.lista_precio.push({ name: 'Precio Detalle', value: item.precio_detalle });
        this.lista_precio.push({ name: 'Precio Oferta', value: item.precio_oferta });
        this.lista_precio.push({ name: 'Precio Mayor', value: item.precio_mayor });
        this.filled=false;
        this.disabled=false;
        this.d_products=false;
    },
    searchPrecio(tipo){
        const found = this.lista_precio.filter( res => res.name == tipo);
        if(found.length!=0){
            this.precio=found[0].value
        } else {
            this.precio=0
        }
    },
    async addProducts(){
        if(this.sku!='' && this.cantidad!='' && this.precio!=''){
            //buscamos si ya existe el producto
            const found = this.items.filter(res => res.sku == this.sku);
            if(found.length!=0){
                const new_precio = parseFloat(this.precio);
                const new_cantidad = parseFloat(found[0].vcantidad) + parseFloat(this.cantidad);
                const new_total = parseFloat(parseFloat(new_cantidad) * parseFloat(new_precio)).toFixed(0);
                found[0].precio = new Intl.NumberFormat('de-DE').format(new_precio);
                found[0].vprecio = new_precio;
                found[0].cantidad = new Intl.NumberFormat('de-DE').format(new_cantidad);
                found[0].vcantidad = new_cantidad;
                found[0].total = new Intl.NumberFormat('de-DE').format(new_total);
                found[0].vtotal = new_total
            } else {
                const total = parseFloat(parseFloat(this.precio)*parseFloat(this.cantidad)).toFixed(0);
                this.items.push({
                    sku: this.sku,
                    producto: this.producto,
                    variante: this.variante,
                    precio: new Intl.NumberFormat('de-DE').format(this.precio),
                    vprecio: this.precio,
                    cantidad: new Intl.NumberFormat('de-DE').format(this.cantidad),
                    vcantidad: this.cantidad,
                    total: new Intl.NumberFormat('de-DE').format(total),
                    vtotal: total,
                    peso: this.peso,
                    volumen: this.volumen,
                })
            };
            this.calcularPedido()
       }
    },
    calcularPedido(){
        //reestablecer variables,
        this.neto = 0;
        this.descuento = 0;
        this.afecto = 0;
        this.iva = 0;
        this.total = 0;
        this.peso_despacho = '';
        this.volumen_despacho = '';
        if(this.porciento!=''){ this.txt_desc = this.porciento }
        if(this.items.length!=0){
            //sumamos el neto
            let subtotal = 0;
            let suma_peso = 0;
            let suma_volumen = 0;
            this.items.forEach(element => {
                subtotal = parseFloat(parseFloat(subtotal) + (parseFloat(element.vprecio)*parseFloat(element.vcantidad))).toFixed(0);
                suma_peso = parseFloat(suma_peso) + (parseFloat(element.peso) * parseFloat(element.vcantidad));
                suma_volumen = parseFloat(suma_volumen) + (parseFloat(element.volumen) * parseFloat(element.vcantidad));
            });
            const v_neto = parseFloat(subtotal);
            const v_descuento = parseFloat((parseFloat(subtotal) * parseFloat(this.porciento))/100).toFixed(0);
            const v_afecto = parseFloat(v_neto) - parseFloat(v_descuento);
            const v_iva = parseFloat((parseFloat(v_afecto) * parseFloat(this.impuesto))/100).toFixed(0);
            const v_total = parseFloat(v_afecto) + parseFloat(v_iva);

            this.neto = v_neto;
            this.descuento = v_descuento;
            this.afecto = v_afecto;
            this.iva = v_iva;
            this.total = v_total;
            this.peso_despacho = parseFloat(suma_peso).toFixed(2);
            this.volumen_despacho = parseFloat(suma_volumen).toFixed(2);
        }
    },
    addDescuento(){
        if(this.porciento!=''){
            this.txt_desc = this.porciento;
            this.calcularPedido()
        }
    },
    async deleteLine(fila){
        this.items = this.items.filter(function(dat) {
            return dat.sku !== fila.sku; 
        });
        this.calcularPedido()
    },
    async validateRut(rut){
        const validate = await this.validaRut(rut);
        if(validate){
            this.confirmaFactura()
        } else {
            this.color_snack='error';
            this.mensaje='Rut Invalido';
            this.snack=true
        }
    },
    async validaRut(varRut){
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( varRut ))
        return false;
      var tmp 	= varRut.split('-');
      var digv	= tmp[1]; 
      var ruti 	= tmp[0];
      if(!isNaN(ruti)){
        if ( digv == 'K' ) digv = 'k' ;
        return (this.dv(ruti) == digv );
      } else {
        return false;
      }
    },
    dv(T){
      var M=0,S=1;
      for(;T;T=Math.floor(T/10))
        S=(S+T%10*(9-M++%6))%11;
      return S?S-1:'k';
    },

    // facturacion y despacho
    async leer_region(){
        try {
            const res = await axios.get('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/inv/v1/leer/regiones/');
            const datos=res.data;
            if(datos.length!=0){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.regiones.push(element.Locates)
                    this.regiones_factura.push(element.Locates)
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async leer_ciudad_factura(locate){
        this.ciudades_factura=[];
        this.comunas_factura=[];
        this.comuna_factura='';
        this.ciudad_factura='';
        try {
            const res = await axios.get('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/inv/v1/leer/ciudades/' + locate);
            const datos=res.data;
            if(datos.length!=0){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.ciudades_factura.push(element.Cityes)
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async leer_comuna_factura(locate,city){
        this.comunas_factura=[];
        try {
            const res = await axios.get('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/inv/v1/leer/comunas/' + locate + '/' + city);
            const datos=res.data;
            if(datos.length!=0){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.comunas_factura.push(element.States)
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async leer_ciudad(locate){
        this.ciudades=[];
        this.comunas=[];
        this.comuna_despacho='';
        this.ciudad_despacho='';
        try {
            const res = await axios.get('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/inv/v1/leer/ciudades/' + locate);
            const datos=res.data;
            if(datos.length!=0){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.ciudades.push(element.Cityes)
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async leer_comuna(locate,city){
        this.comunas=[];
        try {
            const res = await axios.get('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/inv/v1/leer/comunas/' + locate + '/' + city);
            const datos=res.data;
            if(datos.length!=0){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.comunas.push(element.States)
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async savePedido(){
        this.loading=true;
        this.numClicks++;
        if(this.numClicks==1){
            if(parseFloat(this.total)!=0){
                //datos del despacho obligatorio
                if(this.contacto_despacho.trim()!=''){
                    //datos de factura si solo selecciona
                    if(this.dte=='Factura'){
                        if(this.rut_factura.trim()!=''){
                            await this.save();
                        } else {
                            this.color_snack='error';
                            this.mensaje='No existen datos de factura';
                            this.snack=true
                        }
                    } else { //boleta
                        await this.save();
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='No existen datos de despacho';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='No existen datos para continuar';
                this.snack=true
            }
        } else {
            this.numClicks=0
        }
        this.loading=false;
    },
    async save(){
        try {
            this.array_pedido=[];
            this.numero_pedido=0;
            //obtener la orden del portal
            const myOrden = await this.obtenerOrder();
            if(parseInt(myOrden)!=0){
                const array_factura = {
                    dte_factura: this.dte,
                    rut_factura: this.rut_factura,
                    razon_factura: this.razon_factura,
                    giro_factura: this.giro_factura,
                    email_factura: this.email_factura,
                    fono_factura: this.fono_factura,
                    region_factura: this.region_factura,
                    direccion_factura: this.direccion_factura,
                    comuna_factura: this.comuna_factura,
                    ciudad_factura: this.ciudad_factura
                };
                const array_despacho={
                    contacto_despacho: this.contacto_despacho,
                    email_despacho: this.email_despacho,
                    fono_despacho: this.fono_despacho,
                    region_despacho: this.region_despacho,
                    direccion_despacho: this.direccion_despacho,
                    comuna_despacho: this.comuna_despacho,
                    ciudad_despacho: this.ciudad_despacho,
                    codigo_postal:'0',
                    costo_despacho: this.costo_despacho,
                    peso_despacho: this.peso_despacho,
                    volumen_despacho: this.volumen_despacho,
                    transporte: this.transporte
                };
                const array_totales = {
                    fecha: this.hoy,
                    neto: this.neto,
                    porciento: this.txt_desc,
                    descuento: this.descuento,
                    afecto: this.afecto,
                    impuesto: this.impuesto,
                    iva: this.iva,
                    total: this.total,
                    observa: this.observa
                };
                //array del pedido
                this.array_pedido={
                    order: myOrden,
                    portal: this.portal,
                    factura: array_factura,
                    despacho: array_despacho,
                    totales: array_totales,
                    detalle: this.items,
                };
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    data :  this.array_pedido
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/order/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.color_snack='success';
                    this.mensaje='La orden fue generada con exito';
                    this.snack=true
                    this.numero_pedido = myOrden;
                    this.btn_grabado=false;
                }
            } else {
                this.color_snack='error';
                this.mensaje='No es posible crear orden, informar a soporte';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
    },
    async obtenerOrder(){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                portal :  this.portal
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/create/order/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){ result = datos[0].ID }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    close_factura(){
        this.rut_factura='';
        this.razon_factura='';
        this.giro_factura='';
        this.email_factura='';
        this.fono_factura='';
        this.region_factura='';
        this.direccion_factura='';
        this.comuna_factura='';
        this.ciudad_factura='';
        this.dialogo_factura=false;
    },
    confirmaFactura(){
        if(this.rut_factura=='' ||
            this.razon_factura=='' ||
            this.giro_factura=='' ||
            this.email_factura=='' ||
            this.fono_factura=='' ||
            this.region_factura=='' ||
            this.direccion_factura=='' ||
            this.comuna_factura=='' ||
            this.ciudad_factura=='')
        {    
            this.color_snack='error';
            this.mensaje='Todos los datos son obligatorios';
            this.snack=true
        } else {
            this.dialogo_factura=false;
        }
    },
    close_despacho(){
        this.contacto_despacho='';
        this.email_despacho='';
        this.fono_despacho='';
        this.region_despacho='';
        this.direccion_despacho='';
        this.comuna_despacho='';
        this.ciudad_despacho='';
        this.dialogo_despacho=false;
    },
    confirmaDespacho(){
        if(this.transporte=='Retiro en tienda'){
            if(this.contacto_despacho=='' ||
                this.email_despacho=='')
            {           
                this.color_snack='error';
                this.mensaje='Contacto y Email son obligatorios';
                this.snack=true
            } else {
                this.dialogo_despacho=false;
            }
        } else {
            if(this.contacto_despacho=='' ||
                this.email_despacho=='' ||
                this.fono_despacho=='' ||
                this.region_despacho=='' ||
                this.direccion_despacho=='' ||
                this.comuna_despacho=='' ||
                this.ciudad_despacho=='')
            {           
                this.color_snack='error';
                this.mensaje='Todos los datos son obligatorios';
                this.snack=true
            } else {
                this.dialogo_despacho=false;
            }
        }
    }


  }
}
</script>
